
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/communitiesfaqs",
      function () {
        return require("private-next-pages/communitiesfaqs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/communitiesfaqs"])
      });
    }
  